import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import ProductCard from "@/components/store/ProductCard";

export default function Collections() {
  const { slug } = useParams();
  const { collections } = useStore();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (slug) api.get(`/products?collection=${slug}&limit=50`).then((r) => setProducts(r.data)).catch(() => {});
  }, [slug]);

  if (!slug) {
    return (
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-12">
        <h1 className="font-serif text-4xl sm:text-5xl text-center mb-3">Collections</h1>
        <p className="text-sharoa-muted text-center mb-12">Curated edits for every mood ♡</p>
        <div className="grid sm:grid-cols-2 gap-5">
          {collections.map((c) => (
            <Link key={c.slug} to={`/collections/${c.slug}`} data-testid={`collection-${c.slug}`} className="group relative aspect-[16/10] overflow-hidden sh-hover-zoom bg-sharoa-ivory">
              <img src={c.image} alt={c.name} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/25 group-hover:bg-black/35 transition-colors" />
              <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-4">
                <h2 className="font-serif text-3xl">{c.name}</h2>
                <p className="text-sm text-white/80 mt-1">{c.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    );
  }

  const col = collections.find((c) => c.slug === slug);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-12">
      <div className="relative aspect-[21/9] overflow-hidden bg-sharoa-ivory mb-10">
        <img src={col?.image} alt={col?.name} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/30 flex flex-col items-center justify-center text-white">
          <h1 className="font-serif text-4xl sm:text-6xl">{col?.name || "Collection"}</h1>
          <p className="mt-2 text-white/85">{col?.description}</p>
        </div>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {products.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
      {products.length === 0 && <p className="text-center text-sharoa-muted py-16">Styles coming soon ♡</p>}
    </div>
  );
}
